import { create } from "zustand";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  loading: true,
  authInitialized: false,

  decodeToken: (token) => {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  },

  isTokenExpired: (token) => {
    try {
      const decoded = jwtDecode(token);
      if (!decoded || !decoded.exp) return true;

      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp < currentTime;
    } catch (error) {
      return true;
    }
  },

  //  Figure out org_slug from hostname
  getOrgSlug: () => {
    if (typeof window !== "undefined") {
      const hostname = window.location.hostname;

      if (hostname.includes("pinkpaperplay.in")) {
        return "pinkpaperplay";
      } else if (hostname.includes("freepressjournal.in")) {
        return "freepressjournal";
      }
    }
    return "pinkpaperplay";
  },

  createGuestUser: async (org_slug) => {
    try {
      // await axios.post(
      //   `${process.env.REACT_APP_BACKEND_URL}/users/guest`,
      //   { org_slug },
      //   { withCredentials: true }
      // );
      await axios.get(`/init-cookie`, {
        withCredentials: true,
        headers: {
          "X-Referer": document.referrer,
        },
      });

      const hostname = document.referrer
        ? new URL(document.referrer).hostname
        : "";
      const token = Cookies.get(hostname);

      if (token) {
        const userData = jwtDecode(token);
        if (userData) {
          set({ user: userData, isAuthenticated: true });
        }
      }
      return true;
    } catch (error) {
      return false;
    }
  },

  checkAuth: async () => {
    set({ loading: true });
    try {
      const org_slug = useAuthStore.getState().getOrgSlug();
      const hostname = document.referrer
        ? new URL(document.referrer).hostname
        : "";
      // console.log("hostname", hostname);
      const token = Cookies.get(hostname);

      if (!token) {
        await useAuthStore.getState().createGuestUser(org_slug);
      } else {
        if (useAuthStore.getState().isTokenExpired(token)) {
          await useAuthStore.getState().createGuestUser(org_slug);
        } else {
          const userData = useAuthStore.getState().decodeToken(token);
          if (userData) {
            set({ user: userData, isAuthenticated: true });
            // console.log(userData);
          } else {
            await useAuthStore.getState().createGuestUser(org_slug);
          }
        }
      }
    } catch (error) {
      const org_slug = useAuthStore.getState().getOrgSlug();
      await useAuthStore.getState().createGuestUser(org_slug);
    } finally {
      set({ loading: false, authInitialized: true });
    }
  },
}));

export default useAuthStore;
